export default __webpack_public_path__ + "static/hannah-be2f6c979f98a39bf4baf39d684b57b5.jpg";